import * as React from "react";
import { ITriggerManualJob } from "../../../redux/types/ITriggerManualJob";
import ActionButton from "../../../repertoire/components/actionButton/ActionButton";

export interface ISaveAndCloseProps {
    triggerManualJob: (manualJobParameters: ITriggerManualJob) => any;
    manualJobParameters: ITriggerManualJob;
    createNewJob: () => any;
    updateManualJobParams?: (params: any) => void;
    scheduledJobSet?: (value: boolean) => void;
    onError?: (errorMessage: string) => void;
    validate?: () => string[]; 
}

export interface ISaveAndCloseState {
    loading: boolean;
    validationErrors: string[];
}

export class SaveAndClose extends React.Component<ISaveAndCloseProps, ISaveAndCloseState> {
    constructor(props: ISaveAndCloseProps) {
        super(props);
        this.state = { 
            loading : false,
            validationErrors: []
        };
    }

    onClick = async () => {
        const { triggerManualJob, manualJobParameters, createNewJob, scheduledJobSet, onError, validate } = this.props;
        
        if (validate) {
            const errors = validate();
            if (errors.length > 0) {
                this.setState({ validationErrors: errors });
                return;
            }
        }
        
        this.setState({ loading: true, validationErrors: [] });
        
        try {
           const result = await Promise.resolve(triggerManualJob(manualJobParameters));
           this.setState({ loading: false });
           if(result) {
               scheduledJobSet?.(true);
               createNewJob?.();
           }
        } catch (err: any) {
            this.setState({ loading: false });
            onError?.(err?.message || err?.toString() || "An error occurred");
        }
    };

    render() {
        return (
            <>
                {this.state.validationErrors.length > 0 && (
                    <div className="form-group col-md-12 col-sm-12 col-xs-12">
                        <div className="alert alert-danger alert-dismissible">
                            <span>{this.state.validationErrors.join(', ')}</span>
                            <button  type="button" className="close" aria-label="Close" onClick={() => this.setState({ validationErrors: [] })} >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                )}
                <div
                    className="form-group col-lg-4 col-md-4 col-sm-6 col-xs-12">
                    <ActionButton buttonText={"Cancel"} buttonAction={this.props.createNewJob} className={"button btn-defaultSecondary"}/>
                </div>
                <div
                    className="form-group col-lg-4 col-lg-push-4 col-md-4 col-md-push-4 col-sm-6 col-sm-push-0 col-xs-12 col-xs-push-0">
                    <ActionButton buttonText={"Start Job"} buttonAction={this.onClick} disabled={this.state.loading} />
                </div>
            </>
        );
    }
}